import { Reducer } from 'redux';

import { ActionType } from '../../../store/actionTypes';
import { EntityAction, ErrorAction, Action as PlainAction } from '../../types';

export interface MaxAvailablePopulationState {
  size: any;
  isFetching: boolean;
  error: string | null;
}

export const initialState: MaxAvailablePopulationState = {
  size: 0,
  isFetching: false,
  error: null,
};

type Action =
  | PlainAction<ActionType.FETCH_POPULATION_QUERY_STARTED>
  | EntityAction<ActionType.FETCH_POPULATION_QUERY_SUCCEEDED>
  | ErrorAction<ActionType.FETCH_POPULATION_QUERY_FAILED>;

export const maxAvailablePopulationReducer: Reducer<
  MaxAvailablePopulationState,
  Action
> = (state: MaxAvailablePopulationState = initialState, action: Action) => {
  switch (action.type) {
    case ActionType.FETCH_POPULATION_QUERY_STARTED:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case ActionType.FETCH_POPULATION_QUERY_SUCCEEDED: {
      const size = Object.keys(action.payload.entities.populationSize)[0];
      return {
        ...state,
        isFetching: false,
        error: null,
        size,
      };
    }

    case ActionType.FETCH_POPULATION_QUERY_FAILED:
      return {
        ...state,
        isFetchingUsers: false,
        error: action.payload.message,
      };
    default:
      return state;
  }
};

export default maxAvailablePopulationReducer;
